<template>
  <div>
    <div class="analytics-section-overview d-none d-md-block" data-testid="analytics-section-overview">
      <span class="view-count" data-testid="view-count-overview">
        <span v-if="$store.state.stats.length > 0" class="count">
          <span v-if="groupedCount < 200">
            {{groupedCounterDisplay}}
          </span>
          <span v-else-if="viewCount > 150">
            {{viewCounterDisplay}}
          </span>
          <span v-else>
            >200
          </span>
        </span>
        <span v-else class="count">
          {{viewCounterDisplay}}
        </span>
        <span>
          unique views
        </span>
      </span>
      <a href="#" @click.prevent="toggleFullAnalytics" class="view-analytics" data-testid="view-analytics">{{ showFullAnalytics ? "Hide analytics" : "View all analytics" }}</a>
    </div>

    <div v-if="showFullAnalytics" class="analytics-section">
      <div class="view-count-box">
        <async-block :loading="loading">
            <p class="view-count" data-testid="view-count">
              <span v-if="$store.state.stats.length > 0">
                <span v-if="groupedCount < 200">
                  {{groupedCount}}
                </span>
                <span v-else-if="viewCount > 150">
                  {{viewCount}}
                </span>
                <span v-else>
                  >200
                </span>
              </span>
              <span v-else>
                {{viewCount}}
              </span>
            </p>
            <p class="view-count-label">
              unique views
              <pro-badge :visible="trial" :trial="trial" :learnmore_url="analytics_learnmore_url" utm_source="viewer" utm_campaign="upgrade" utm_medium="analytics"></pro-badge>
              </p>
            <a id="upgrade-link" v-if="!trial && !isPaying" href="/plans?utm_source=viewer&utm_campaign=upgrade&utm_medium=analytics">
              <span>upgrade</span> for advanced analytics <pro-badge :visible="true" :trial="trial" :learnmore_url="analytics_learnmore_url" utm_source="viewer" utm_campaign="upgrade" utm_medium="analytics"></pro-badge>
            </a>
        </async-block>
      </div>
      <div class="stats-section" data-testid="stats-section" v-if="upgraded && $store.state.stats.length > 0">
        <div class="stats-header">
          <span>Viewed by</span>
          <span v-if="isVideo">% Viewed</span>
        </div>
        <div v-for="(percentages, email, idx) in groupedStats" :key="idx">
          <div class="stat" v-for="(obj, idx) in percentages" :key="idx">
            <div class="info">
              <span>{{ email }}</span>
              <span class="date" v-if="enterprise">{{ obj.created_at }}</span>
            </div>
            <span class="viewed_pc" v-if="isVideo">{{ obj.percentage }}%</span>
          </div>
        </div>
      </div>
      <div id="download-stats" v-if="enterprise && $store.state.stats.length > 0">
        <a :href="`/analytics_download/${$route.params.slug}`">Export list as CSV</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import track from '@/src/tracking';

import ProBadge from '@cmp/pro_badge.vue';

export default {
  components: { ProBadge },
  props: {
    analytics_learnmore_url: { type: String }
  },
  data: function(){
    return {
      loading: true,
      currentCount: 0,
      counterTime: 1500,
      counterInterval: 20
    };
  },
  mounted: function(){
    this.$store.dispatch('getAnalytics', this.$route.params.slug).then(function(){
      this.loading = false;
    }.bind(this));
  },
  computed: {
    ...mapState({
      isVideo: state => state.item.attributes.item_type === 'video',
      viewCount: state => state.item.attributes.public_visits_count,
      upgraded: state => !state.itemOrganization.attributes.free,
      trial: state => state.currentOrganization.attributes.trial,
      isPaying: state => state.currentOrganization.attributes.is_paying
    }),
    enterprise: function(){
      return this.upgraded && /business/.test(this.gon.plan);
    },
    groupedCount: function() {
      return this.$store.getters.groupedCount;
    },
    groupedStats: function() {
      return this.$store.getters.groupedStats;
    },
    groupedCounterDisplay: function() {
      return this.counterDisplay(this.groupedCount);
    },
    viewCounterDisplay: function() {
      return this.counterDisplay(this.viewCount);
    },
    showFullAnalytics: function(){
      return this.$route.name == 'analytics';
    }
  },
  methods: {
    counterDisplay: function(max) {
      const vm = this;

      if (vm.currentCount >= max) {
        vm.currentCount = max;
        return max;
      } else {
        setTimeout(function() { vm.currentCount += vm.itemsPerIncrement(max) }, vm.counterInterval);
      }
      return Math.floor(vm.currentCount);
    },
    itemsPerIncrement: function(max) {
      const items_per_ms = max / this.counterTime;
      return items_per_ms * this.counterInterval;
    },
    toggleFullAnalytics: function(){
      if(!this.showFullAnalytics) {
        this.$router.push({ name: 'analytics', params: { slug: this.$route.params.slug }})
        track('viewer_analytics_teaser_clicked', { view_count: this.viewCount });
      } else {
        this.$router.push({ name: 'viewer', params: { slug: this.$route.params.slug }})
      }
    }
  }
}


</script>

<style lang="scss" scoped>
  @import "application.scss";

  #upgrade-link {
    font-size: .9rem;
    text-decoration: none;

    span {
      color: $orange;
    }
  }

  .analytics-section-overview {
    padding: 1rem;
    border-radius: 4px;
    box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.15);
    background: white;
    margin-top: 1rem;
    font-size: 0.75rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;

    .count {
      font-weight: bold;
    }

    .view-analytics {
      color: $bright-blue;
      float: right;
      cursor: pointer;
    }
  }

  .analytics-section {
    margin-top: 1rem;

    #download-stats {
      border-radius: 4px;
      box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.15);
      background-color: $white;
      text-align: center;
      padding: 5px;

      a {
        font-size: 0.8rem;
        font-weight: bold;
        text-decoration: none;
      }
    }

    .view-count-box {
      height: 7.75rem;
      border-radius: 4px;
      box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.15);
      background-color: $white;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;

      .view-count {
        width: 14rem;
        height: 4rem;
        font-size: 4rem;
        font-weight: 590;
        color: $bright-blue;
        margin: 0 0 0.25rem;
        font-family: SFPro;
        font-stretch: normal;
        font-style: normal;
        font-variation-settings: "opsz" 18;
        line-height: 1;
        letter-spacing: normal;
        text-align: center;
      }

      .view-count-label {
        width: 14rem;
        height: 1.5rem;
        font-family: SFPro;
        font-size: 1.125rem;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
        text-align: center;
        color: $dark-gray;
      }
    }

    .stats-section {
      margin-top: 1rem;
      color: $dark-gray;
      max-height: 27rem;
      overflow: auto;
      overflow-x: hidden;

      .stats-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 1rem;
        font-family: SFPro;
        font-size: 0.75rem;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        background-color: $white;
        border-radius: 4px;
        height: 2rem;
        letter-spacing: normal;
      }

      .stat {
        font-family: SFPro;
        font-size: 0.75rem;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: $dark-gray;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 1px;
        padding: 1rem;
        background-color: $white;
        border-radius: 4px;

        .info {
          display: flex;
          flex-direction: column;

          .date {
            font-size: 10px;
            color: $c-dark-gray;
          }
        }

        .viewed_pc {
          color: $c-dark-gray;
        }
      }
    }
  }
</style>
